import { render } from "./ReviewListPage.vue?vue&type=template&id=ffd2ca28&scoped=true"
import script from "./ReviewListPage.vue?vue&type=script&lang=js"
export * from "./ReviewListPage.vue?vue&type=script&lang=js"

import "./ReviewListPage.vue?vue&type=style&index=0&id=ffd2ca28&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ffd2ca28"

export default script